// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import type { InlineRichText } from '../../internal/types';
import { Button } from '../../internal/Button';

const blockVariantMap = {
  Low: 'White',
  Medium: 'DefaultContrast',
  High: 'Featured',
  Dark: 'Dark',
};

type LinkType = {|
  text: string,
  href: string,
|};

type PropTypes = {|
  background: 'Low' | 'Medium' | 'High' | 'Dark',
  children: InlineRichText,

  firstCtaBtn: LinkType,
|};

const findButtonVariant = (background: 'Low' | 'Medium' | 'High' | 'Dark') => {
  switch (background) {
    case 'Low':
    case 'Medium':
    case 'High':
      return 'Black';

    case 'Dark':
      return 'Citrus';

    default:
      return 'Citrus';
  }
};

const CtaTextMini = (props: PropTypes) => {
  return (
    <PageContentBlock background={blockVariantMap[props.background]} layout="Thin" compact>
      <div className={styles.ctaText}>
        {props.children && <span>{props.children}</span>}
        &nbsp; &nbsp;
        <Button
          variant={findButtonVariant(props.background)}
          onClick={() => window.open(props.firstCtaBtn.href, '_self')}
        >
          {props.firstCtaBtn.text}
        </Button>
      </div>
    </PageContentBlock>
  );
};

CtaTextMini.defaultProps = {
  background: 'High',
};

export default CtaTextMini;
